module.exports = __webpack_public_path__ + "static/media/taltech.f735c18b.svg";